export const R1_RELEASE_FLAGS = {
  openPilotRegistration: true,
  bathroomCatalog: false,
  seoProblemPages: false,
  freeProjectLimit: false,
  // Assistant (Doradca AI) is hidden in the production pilot. It may only appear
  // in DEV builds. Keep this false until the assistant is pilot-ready.
  showAssistant: false,
} as const;
